import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { videoViews10SecConfig } from '../videoViews10Sec';

export const videoViews10SecMVConfig = {
    ...videoViews10SecConfig,
    tooltip: false,
    name: 'kpi.facebook.video_views_10_sec',
    id: 'video_views_10s',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
